import { render, staticRenderFns } from "./VideoPage.vue?vue&type=template&id=5aa5670a&scoped=true"
import script from "./VideoPage.vue?vue&type=script&lang=js"
export * from "./VideoPage.vue?vue&type=script&lang=js"
import style0 from "./VideoPage.vue?vue&type=style&index=0&id=5aa5670a&prod&lang=scss"
import style1 from "./VideoPage.vue?vue&type=style&index=1&id=5aa5670a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa5670a",
  null
  
)

export default component.exports